/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBullhornOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m16.929 18.343 4.364 4.364 1.414-1.414-20-20-1.414 1.414L6.586 8H2v6h3v3c0 .827.24 2.044.989 3.084C6.774 21.175 8.074 22 10 22c.827 0 2.045-.24 3.084-.988.992-.715 1.764-1.855 1.896-3.504l1.949.835zm-3.808-3.808-5.12-2.194V9.659l.17-.073 4.95 4.95zM6.001 10v2H4v-2h2zm1 4.088 6 2.571V17c0 1.275-.51 1.975-1.085 2.39-.627.45-1.41.61-1.916.61-1.274 0-1.974-.508-2.388-1.083C7.16 18.289 7 17.506 7 17v-2.912zm3.437-7.65 1.524 1.524L20 4.516V16l2 2V1.483L10.438 6.438z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBullhornOff as BullhornOff };
